import mixpanel from "mixpanel-browser";

mixpanel.init(process.env.PROJECT_TOKEN);

export default mixpanel;